// No "use server" directive - This is a client-side utility

// No server-side imports like 'redirect' or 'cookies' needed here

/**
 * Clears authentication-related items from localStorage.
 * This function MUST be called from a client-side component ("use client").
 * The calling component is responsible for handling redirection after cleanup.
 */
export function clearAuthLocalStorage() {
  // Ensure this code only runs in the browser environment
  if (typeof window !== 'undefined' && window.localStorage) {
    console.log('Clearing auth data from localStorage...'); // Optional: for debugging
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    localStorage.removeItem('auth_entity');
    localStorage.removeItem('auth_coa');
  } else {
    // This case should ideally not happen if called correctly from client-side
    console.warn('Attempted to clear localStorage outside of browser environment or localStorage is unavailable.');
  }
}
